import { IGif } from "services/types";

const getHost = () => {
  return window.location.host === "staging.redgifs.com" ? window.location.host : "redgifs.com";
};

export const getShareUser = (userId: string) => {
  return `https://${getHost()}/users/${userId}`;
};

export const getShareNiche = (niche: string) => {
  return `https://${getHost()}/niches/${niche}`;
};

const getGifLink = (id: string): string => {
  return `https://${getHost()}/watch/${id}`;
};

export const getSharedLink = (type: string, item: any) => {
  return type === "collection" ? `https://${getHost()}/users/${item.userId}/collections/${item.folderId}`
    : `https://${getHost()}/watch/${item.id}`;
};

const getIframeUrl = (gif: IGif) => {
  return `https://${getHost()}/ifr/${gif.id}`;
};

export const getFixedEmbedCode = (gif: IGif) => {
  return (
    // eslint-disable-next-line
    "<iframe src='" +
    getIframeUrl(gif) +
    "' frameborder='0' scrolling='no' " +
    " allowfullscreen width='" +
    gif.width +
    "' height='" +
    gif.height +
    "'></iframe>" +
    "<p><a href='" +
    getSharedLink("gif", gif) +
    "'>via RedGIFs</a></p>"
  );
};

export const getGifEmbedCode = (id: string): string => {
  return `<iframe src="https://${getHost()}/ifr/${id}" frameborder="0" scrolling="no" allowfullscreen width="640" height="480"></iframe>`;
};

export const getResponsiveEmbedCode = (gif: IGif) => {
  const ratio = gif.width / gif.height;
  // eslint-disable-next-line
  const paddingBottom = (100 / ratio).toFixed(2);
  return (
    // eslint-disable-next-line
    "<div style='position:relative; padding-bottom: " +
    paddingBottom +
    "%'>" +
    "<iframe src='" +
    getIframeUrl(gif) +
    "' frameBorder='0' scrolling='no' " +
    "width='100%' height='100%' style='position:absolute; top:0; left:0;' allowFullScreen></iframe></div>" +
    "<p><a href='" +
    getSharedLink("gif", gif) +
    "'>via RedGIFs</a></p>"
  );
};

export const copyGifLink = (id: string): void => {
  const gifLink = getGifLink(id);
  navigator.clipboard.writeText(gifLink);
};

export const sendGifToReddit = (id: string): void => {
  const gifLink = getGifLink(id);
  const url = `https://www.reddit.com/submit?url=${encodeURIComponent(gifLink)}`;
  window.open(url, "_blank");
};

export const sendGifToTwitter = (id: string): void => {
  const gifLink = getGifLink(id);
  const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(gifLink)}`;
  window.open(url, "_blank");
};
